import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * ブラウザタブのタイトルを設定するカスタムフック
 *
 * フォーマット: {{画面名}} | WiseVine BnS 事業立案+AI
 *
 * @param title - 画面名（例: '事業一覧', '歳出比較・査定作成'）
 *
 * @example
 * // 静的タイトル
 * useDocumentTitle('事業っs一覧');
 *
 * @example
 * // 動的タイトル
 * const { data } = useGetProject(projectId);
 * useDocumentTitle(data?.name ? `${data.name} | 事業詳細` : '事業詳細');
 */
export const useDocumentTitle = (title?: string) => {
  const { t } = useTranslation();
  const appTitle = t('app.title');

  useEffect(() => {
    if (title) {
      document.title = `${title} | ${appTitle}`;
    } else {
      document.title = appTitle;
    }
  }, [title, appTitle]);
};
